import React, { useState } from 'react';
import styled from '@emotion/native';
import { City } from '@/shared/types/generated';
import useExploreStore from '@/stores/useExploreStore';
import { Title } from './styledComponents';
import { Menu, TouchableRipple } from 'react-native-paper';
import { BodyText } from '@/shared/components/StyledText';
import { borderColor, green, white } from '@/shared/styles/colors';
import { Entypo } from '@expo/vector-icons';
import { ScrollView } from 'react-native';
import Checkbox from '@/shared/components/Checkbox';
import { getCityLabel } from './utils';

const Container = styled.View({
  marginBottom: 32,
});

const CityFilter: React.FC = () => {
  const { filters, setFilters } = useExploreStore();
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const handleCityChange = (city: City) => {
    setFilters({
      cities: filters.cities.includes(city) ? [] : [city],
    });
    setIsDropdownVisible(false);
  };

  const getSelectedLabel = () => {
    if (filters.cities.length === 0) {
      return 'All Cities';
    }
    return getCityLabel(filters.cities[0]);
  };

  return (
    <Container>
      <Title>Filter by City:</Title>
      <Menu
        visible={isDropdownVisible}
        onDismiss={() => setIsDropdownVisible(false)}
        anchor={
          <DropdownButton
            onPress={() => setIsDropdownVisible(!isDropdownVisible)}
          >
            <DropdownContent>
              <DropdownContentText>{getSelectedLabel()}</DropdownContentText>
              <Entypo
                name="chevron-thin-down"
                size={16}
                color={green}
                style={
                  isDropdownVisible
                    ? {
                        transform: [{ rotate: '180deg' }],
                      }
                    : {}
                }
              />
            </DropdownContent>
          </DropdownButton>
        }
        contentStyle={menuContentStyle}
      >
        <ScrollView>
          {Object.values(City).map((city) => {
            const isSelected = filters.cities.includes(city);
            return (
              <MenuItem key={city} onPress={() => handleCityChange(city)}>
                <CheckboxContainer>
                  <Checkbox
                    checked={isSelected}
                    onPress={() => handleCityChange(city)}
                  />
                </CheckboxContainer>
                <MenuItemText>{getCityLabel(city)}</MenuItemText>
              </MenuItem>
            );
          })}
        </ScrollView>
      </Menu>
    </Container>
  );
};

const DropdownButton = styled(TouchableRipple)({
  backgroundColor: white,
  borderRadius: 35,
  paddingLeft: 26,
  marginBottom: 28,
  height: 48,
  justifyContent: 'center',
  borderColor: borderColor,
  borderWidth: 1,
  width: 326,
});

const DropdownContent = styled.View({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  flex: 1,
  paddingRight: 16,
});

const DropdownContentText = styled(BodyText)({
  color: green,
});

const menuContentStyle = {
  backgroundColor: white,
  width: 326,
  borderRadius: 10,
  maxHeight: 260,
};

const MenuItem = styled.TouchableOpacity({
  flexDirection: 'row',
  alignItems: 'center',
  paddingVertical: 12,
  paddingHorizontal: 16,
});

const CheckboxContainer = styled.View({
  marginRight: 12,
});

const MenuItemText = styled(BodyText)({
  color: green,
  fontSize: 14,
});

export default CityFilter;
